import { Box, Button, Card, CardContent, CardHeader, IconButton, Input, InputAdornment } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import TableFilter from "../../components/shared/TableFilter";
import { STATUS_OPTIONS_LIST } from "../../utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { userServices } from "../../services/AllServices";
import { Loader } from "../../components/CustomLoader";
import CustomPagination from "../../components/CustomPagination";
import errorHandler from "../../utils/errorHandler";
import DataTable from "react-data-table-component";
import CloseIcon from "@mui/icons-material/Close";
import { debounce } from "lodash";

export default function ReffrealList() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchItem, setSearchItem] = useState("");
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [status, setStatus] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loaderDelay, setLoaderDelay] = useState(false);
  const [totalInvites, setTotalInvites] = useState(0);
  const [totalAccepted, setTotalAccepted] = useState(0);


  const fetchUsers = async (query) => {
    const body = {
      searchItem: query || "",
      pageNumber: currentPage,
      pageSize: pageSize,
      status: status,
      referredBy: id,
    };
    try {
      setIsLoading(true);
      setLoaderDelay(false);
      const res = await userServices.getReferById(body);

      setTimeout(() => {
        if (res.status === 200) {
          setData(res?.data?.data);
          setTotalPages(res?.data?.meta?.total);
          setTotalInvites(res?.data?.meta?.totalSignUps);
          setTotalAccepted(res?.data?.meta?.totalPurchases);
          setIsLoading(false);
          setLoaderDelay(true);
        }
      }, 500);
    } catch (err) {
      setData(err?.response?.data?.message?.data);
      errorHandler(err);
      setLoaderDelay(false);
      setIsLoading(false);
    }
  };

  const debouncedSearch = useCallback(
    debounce((query) => fetchUsers(query), 400),
    [currentPage, pageSize, status]
  );

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchItem(query);
    debouncedSearch(query);
  };

  const handlePageChange = (page) => setCurrentPage(page);

  useEffect(() => {
    fetchUsers(searchItem);
  }, [currentPage, pageSize, status, id]);

  const columns = [
    {
      name: "S.No.",
      width: 100,
      cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      name: 'Referred User',
      width: 200,
      selector: (params) => params?.referredUser?.name || "-",
    },
    {
      name: 'User Email',
      width: 250,
      selector: (params) => params?.referredUser?.email || "-",
    },
    {
      name: 'Referred By',
      width: 200,
      selector: (params) => params?.referredBy?.name || "-",
    },
    {
      name: 'Referral Code',
      width: 150,
      selector: (params) => params?.referralCode || "-",
    },
    {
      name: 'Referral Date',
      width: 180,
      selector: (params) =>
        new Date(params?.referralDate).toLocaleDateString(),
    },
    {
      name: 'Purchased',
      width: 130,
      selector: (params) => params?.firstPurchase?.purchased ? "Yes" : "No",
    },
  ];

  const cssValue = {
    display: "flex",
    gap: 2,
    backgroundColor: "#1e1e1e",
    padding: "8px 16px",
    borderRadius: "12px",
    boxShadow: "0px 0px 8px rgba(0,0,0,0.2)",
    borderColor: 'white',
    alignItems: "center",
    minWidth: 150,
    marginRight: "2%",
    border: '1px solid white',
  }

  return (

    <Card>
      {/* <CardHeader title="Refer User" /> */}
          <IconButton onClick={() => navigate(-1)} aria-label="go-back" style={{margin:"28px" , marginBottom:'0px'}}>
            <ArrowBackIcon />
          </IconButton>

      <CardHeader
        title="Refer User"
      />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >

        <Box sx={cssValue}>
          <Box sx={{ textAlign: "center", marginLeft: "2%", }}>
            <Box sx={{ fontSize: 18 }}>Accepted: <span style={{ fontSize: 18, fontWeight: 600, color: "#66BB6A" }}>{totalAccepted}</span> </Box>
          </Box>
        </Box>
        <Box
          sx={cssValue}
        >
          <Box sx={{ textAlign: "center", marginRight: "2%", }}>
            <Box sx={{ fontSize: 18 }}>Invites : <span style={{ fontSize: 18, fontWeight: 600, color: "#4FC3F7" }}>{totalInvites}</span> </Box>
          </Box>
        </Box>

        <Input
          value={searchItem}
          placeholder="Search"
          onChange={handleSearchChange}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="clear-search"
                onClick={() => {
                  const cleared = "";
                  setSearchItem(cleared);
                  debouncedSearch(cleared);
                }}
              >
                <CloseIcon />
              </IconButton>
            </InputAdornment>
          }
        />
        <Button
          size="large"
          type="submit"
          variant="contained"
          sx={{ ml: 3, mr: 3 }}
          onClick={() => navigate("/user-management/add")}
        >
          Add
        </Button>
      </Box>

      <CardContent>
        <DataTable
          customStyles={{
            headCells: {
              style: {
                fontSize: "15px",
                fontWeight: "bold",
              },
            },
          }}
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={totalPages}
          onChangePage={handlePageChange}
          paginationPerPage={pageSize}
          paginationRowsPerPageOptions={[10, 20, 50]}
          onChangeRowsPerPage={(currentRowsPerPage) =>
            setPageSize(currentRowsPerPage)
          }
          progressPending={isLoading || !loaderDelay}
          progressComponent={<Loader />}
          paginationComponent={(props) => (
            <CustomPagination {...props} currentPage={currentPage} />
          )}
          className="custom"
        />
      </CardContent>
    </Card>
  );
}